/* =========================================================
WOMUSE · PHOTO ZOOM AND PRODUCT PHOTO VIEWER (V26)

1. WomuseZoom: one way of zooming used everywhere (product page viewer
   and the gift photo in the bag). Tap to zoom in, tap again to come
   closer to the same spot, a third tap zooms back out. Pinch works too.
   Drag with one thumb while zoomed; swipe for the next photo when not.

2. The product page viewer, in place of the theme's own (the theme's
   scripts are untouched): arrows as on the product page, the thin
   line, a pressed-in X and magnifier, "Tap or pinch to zoom" the first
   time. The magnifier opens a column of controls (up, down, left,
   right, zoom out, zoom in, back to the full photo).

Photos load at 1400px; the sharper 2000px copy only once she zooms.
========================================================= */
(function () {
  'use strict';

  var LEVELS = [1, 2, 3.5];
  function qa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* ---------------- 1. WomuseZoom ---------------- */

  function attach(stage, img, o) {
    o = o || {};
    var z = { s: 1, tx: 0, ty: 0, hi: false };
    var root = o.root || stage;
    function bounds() {
      var st = stage.getBoundingClientRect();
      var nw = img.naturalWidth || 1, nh = img.naturalHeight || 1;
      var k = Math.min(st.width / nw, st.height / nh), w = nw * k, h = nh * k;
      return { x: Math.max(0, (w * z.s - st.width) / 2), y: Math.max(0, (h * z.s - st.height) / 2), W: st.width, H: st.height, cx: st.left + st.width / 2, cy: st.top + st.height / 2 };
    }
    function apply(animate) {
      var b = bounds();
      z.tx = Math.max(-b.x, Math.min(b.x, z.tx));
      z.ty = Math.max(-b.y, Math.min(b.y, z.ty));
      img.style.transition = animate ? 'transform 0.3s ease' : 'none';
      img.style.transform = 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')';
      root.classList.toggle('is-zoomed', z.s > 1.01);
      if (z.s > 1.01 && !z.hi && o.hi) {
        z.hi = true; var hs = o.hi();
        if (hs) { var pre = new Image(); pre.onload = function () { if (z.hi) img.src = hs; }; pre.src = hs; }
      }
      if (o.change) o.change(z);
    }
    function zoomTo(s, px, py) {
      var b = bounds();
      var ox = (px == null ? b.cx : px) - b.cx, oy = (py == null ? b.cy : py) - b.cy, r = s / z.s;
      z.tx = ox - (ox - z.tx) * r; z.ty = oy - (oy - z.ty) * r; z.s = s;
      if (s <= 1) { z.tx = 0; z.ty = 0; }
      apply(true);
    }
    function idx() { var k = 0; LEVELS.forEach(function (l, i) { if (z.s >= l - 0.01) k = i; }); return k; }
    var api = {
      state: z,
      tap: function (px, py) { var k = idx(); zoomTo(k + 1 < LEVELS.length ? LEVELS[k + 1] : 1, px, py); },
      zoomIn: function () { var k = idx(); if (k + 1 < LEVELS.length) zoomTo(LEVELS[k + 1]); },
      zoomOut: function () { var k = idx(); zoomTo(z.s > LEVELS[k] + 0.01 ? LEVELS[k] : LEVELS[Math.max(0, k - 1)]); },
      pan: function (dx, dy) { z.tx += dx; z.ty += dy; apply(true); },
      reset: function () { z.s = 1; z.tx = 0; z.ty = 0; z.hi = false; apply(false); },
      max: function () { return z.s >= LEVELS[LEVELS.length - 1] - 0.01; },
      step: function () { var b = bounds(); return Math.min(b.W, b.H) * 0.25; }
    };
    var T = null;
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    stage.addEventListener('touchstart', function (e) {
      if (o.touched) o.touched();
      var t = e.touches;
      if (t.length === 2) T = { pinch: true, d0: dist(t), s0: z.s, mx: (t[0].clientX + t[1].clientX) / 2, my: (t[0].clientY + t[1].clientY) / 2 };
      else if (t.length === 1) T = { x0: t[0].clientX, y0: t[0].clientY, tx: z.tx, ty: z.ty, at: Date.now(), moved: false };
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!T) return;
      e.preventDefault(); e.stopPropagation();
      var t = e.touches;
      if (T.pinch && t.length === 2) {
        var s = Math.max(1, Math.min(4, T.s0 * dist(t) / T.d0)), b = bounds();
        var ox = T.mx - b.cx, oy = T.my - b.cy, r = s / z.s;
        z.tx = ox - (ox - z.tx) * r; z.ty = oy - (oy - z.ty) * r; z.s = s;
        apply(false); return;
      }
      if (t.length !== 1 || T.pinch) return;
      var dx = t[0].clientX - T.x0, dy = t[0].clientY - T.y0;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) T.moved = true;
      if (z.s > 1.01) { z.tx = T.tx + dx; z.ty = T.ty + dy; apply(false); }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      if (!T || e.touches.length) return;
      var g = T; T = null;
      if (g.pinch) { if (z.s < 1.05) zoomTo(1); return; }
      var c = e.changedTouches[0], dx = c.clientX - g.x0, dy = c.clientY - g.y0;
      if (!g.moved && Date.now() - g.at < 350) { e.preventDefault(); api.tap(c.clientX, c.clientY); return; }
      if (z.s <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && o.swipe) o.swipe(dx < 0 ? 1 : -1);
      else if (z.s <= 1.01 && dy > 110 && Math.abs(dy) > Math.abs(dx) && o.down) o.down();
    }, { passive: false });
    stage.addEventListener('click', function (e) {
      if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
      e.preventDefault(); e.stopPropagation();
      api.tap(e.clientX, e.clientY);
    });
    return api;
  }
  window.WomuseZoom = { attach: attach };

  /* ---------------- 2. product page viewer ---------------- */

  if (!document.body.classList.contains('template-product')) return;

  function src(u, w) { u = String(u).replace(/^\/\//, 'https://'); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function svg(d, w) { return '<svg width="' + (w || 18) + '" height="' + (w || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var I = {
    x: svg('<path d="M6 6l12 12M18 6L6 18"/>', 16),
    up: svg('<path d="M5 15l7-7 7 7"/>'),
    down: svg('<path d="M5 9l7 7 7-7"/>'),
    left: svg('<path d="M15 5l-7 7 7 7"/>'),
    right: svg('<path d="M9 5l7 7-7 7"/>'),
    zin: svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/>'),
    zout: svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M8.5 11h5"/>')
  };
  var V = null;

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('main .lightbox-image');
    if (!a) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var box = a.closest('.product__media') || document;
    var list = [];
    qa('.lightbox-image', box).forEach(function (x) {
      var h = x.getAttribute('data-pswp-src') || x.getAttribute('href');
      if (h && list.indexOf(h) < 0) list.push(h);
    });
    var at = list.indexOf(a.getAttribute('data-pswp-src') || a.getAttribute('href'));
    var im = a.querySelector('img');
    open(list, Math.max(0, at), im ? im.getAttribute('alt') || '' : '');
  }, true);

  function open(list, i, alt) {
    var el = document.createElement('div');
    el.className = 'wpv'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Photos');
    el.innerHTML =
      '<div class="wpv__stage"><img class="wpv__img" alt="" draggable="false"></div>' +
      '<button type="button" class="wpv__press wpv__x" data-wpv="close" aria-label="Close">' + I.x + '</button>' +
      '<button type="button" class="wpv__press wpv__zoom" data-wpv="rail" aria-label="Zoom controls" aria-expanded="false">' + I.zin + '</button>' +
      (list.length > 1 ? '<button type="button" class="wpv__nav wpv__nav--prev" data-wpv="prev" aria-label="Previous photo"><span aria-hidden="true">‹</span></button><button type="button" class="wpv__nav wpv__nav--next" data-wpv="next" aria-label="Next photo"><span aria-hidden="true">›</span></button>' : '') +
      '<span class="wpv__line" aria-hidden="true"><span style="width:' + (100 / list.length) + '%"></span></span>' +
      '<div class="wpv__rail" aria-label="Zoom controls">' +
        '<button type="button" class="wpv__press" data-wpv="pan-up" aria-label="Move up">' + I.up + '</button>' +
        '<button type="button" class="wpv__press" data-wpv="pan-down" aria-label="Move down">' + I.down + '</button>' +
        '<button type="button" class="wpv__press" data-wpv="pan-left" aria-label="Move left">' + I.left + '</button>' +
        '<button type="button" class="wpv__press" data-wpv="pan-right" aria-label="Move right">' + I.right + '</button>' +
        '<button type="button" class="wpv__press wpv__gap" data-wpv="out" aria-label="Zoom out">' + I.zout + '</button>' +
        '<button type="button" class="wpv__press" data-wpv="in" aria-label="Zoom in">' + I.zin + '</button>' +
        '<button type="button" class="wpv__press wpv__gap" data-wpv="reset" aria-label="Back to the full photo">' + I.x + '</button>' +
      '</div>' +
      '<div class="wpv__hint" aria-hidden="true">' + svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/>', 44) + '<span>Tap or pinch to zoom</span></div>';
    document.body.appendChild(el);
    var img = el.querySelector('.wpv__img');
    V = { el: el, list: list, i: i, alt: alt, prevOverflow: document.documentElement.style.overflow };
    V.z = attach(el.querySelector('.wpv__stage'), img, {
      root: el,
      hi: function () { return src(V.list[V.i], 2000); },
      swipe: function (d) { show(V.i + d); },
      down: function () { close(); },
      touched: function () { el.classList.remove('has-hint'); },
      change: function (z) {
        var zin = el.querySelector('.wpv__rail [data-wpv="in"]'); if (zin) zin.disabled = V.z && V.z.max();
        if (z.s <= 1.01) rail(false);
      }
    });
    document.documentElement.style.overflow = 'hidden';
    show(i);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    var seen = false; try { seen = sessionStorage.getItem('wpv-hint') === '1'; sessionStorage.setItem('wpv-hint', '1'); } catch (er) {}
    if (!seen) { el.classList.add('has-hint'); setTimeout(function () { el.classList.remove('has-hint'); }, 2400); }
    var x = el.querySelector('[data-wpv="close"]'); if (x) x.focus({ preventScroll: true });
  }

  function rail(on) {
    if (!V) return;
    V.el.classList.toggle('has-rail', on);
    var b = V.el.querySelector('[data-wpv="rail"]'); if (b) b.setAttribute('aria-expanded', String(on));
  }

  function close() {
    if (!V) return;
    var el = V.el;
    document.documentElement.style.overflow = V.prevOverflow;
    V = null;
    el.classList.remove('is-in');
    setTimeout(function () { el.remove(); }, 220);
  }

  function show(i) {
    var n = V.list.length;
    V.i = Math.max(0, Math.min(n - 1, i));
    var img = V.el.querySelector('.wpv__img');
    img.src = src(V.list[V.i], 1400);
    img.alt = V.alt;
    V.z.reset();
    var ln = V.el.querySelector('.wpv__line span'); if (ln) ln.style.left = (100 / n * V.i) + '%';
    var pv = V.el.querySelector('[data-wpv="prev"]'), nx = V.el.querySelector('[data-wpv="next"]');
    if (pv) pv.hidden = V.i === 0;
    if (nx) nx.hidden = V.i === n - 1;
  }

  document.addEventListener('click', function (e) {
    if (!V || !V.el.contains(e.target)) return;
    var b = e.target.closest('[data-wpv]');
    if (!b) return;
    e.preventDefault();
    var a = b.getAttribute('data-wpv'), z = V.z, st = z.step();
    if (a === 'close') close();
    else if (a === 'prev') show(V.i - 1);
    else if (a === 'next') show(V.i + 1);
    else if (a === 'rail') { var on = !V.el.classList.contains('has-rail'); if (on && z.state.s <= 1.01) z.zoomIn(); rail(on); }
    else if (a === 'in') z.zoomIn();
    else if (a === 'out') z.zoomOut();
    else if (a === 'reset') z.reset();
    else if (a === 'pan-up') z.pan(0, st);
    else if (a === 'pan-down') z.pan(0, -st);
    else if (a === 'pan-left') z.pan(st, 0);
    else if (a === 'pan-right') z.pan(-st, 0);
  });

  document.addEventListener('keydown', function (e) {
    if (!V) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight' && V.z.state.s <= 1.01) show(V.i + 1);
    else if (e.key === 'ArrowLeft' && V.z.state.s <= 1.01) show(V.i - 1);
  }, true);
})();

/* =========================================================
WOMUSE · SWIPE ON SWITCHES (V32)
Hold a switch (UK / US / EU, the metal circles, the metal choice in the
bag sheets) and slide: left picks the option to the left, right the one
to the right. One step per slide; a tap works as before.
========================================================= */
(function () {
  'use strict';
  var GROUPS = '.wv20-sw, .product__color-swatches--inner, .wv11-swatches, .wv11-edit__sw';
  var t = null;
  function opts(g) { return Array.prototype.slice.call(g.querySelectorAll('button')).filter(function (b) { return b.offsetParent; }); }
  function isOn(b) { return b.getAttribute('aria-pressed') === 'true' || b.classList.contains('selected'); }
  document.addEventListener('touchstart', function (e) {
    var g = e.touches.length === 1 && e.target.closest && e.target.closest(GROUPS);
    t = g ? { g: g, x: e.touches[0].clientX, y: e.touches[0].clientY, done: false } : null;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!t || t.done) return;
    var dx = e.touches[0].clientX - t.x, dy = e.touches[0].clientY - t.y;
    if (Math.abs(dx) < 28 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    t.done = true;
    var list = opts(t.g), i = list.findIndex(isOn), step = dx < 0 ? -1 : 1;
    if (i < 0) i = dx < 0 ? list.length : -1;
    for (var j = i + step; j >= 0 && j < list.length; j += step) {
      if (!list[j].disabled) { list[j].click(); return; }
    }
  }, { passive: true });
  document.addEventListener('touchend', function () { t = null; }, { passive: true });
})();
